import { TICK_MARK } from "src/constants/images";
import React, { useState } from "react";

import Modal from "./Modal";

const LedgerWalletAddressModal = ({
  isVisible,
  onClose,
  onNext,
  onPrevious,
  firstPage,
  onConfirm,
  currentPage,
  addressList,
  walletPaths,
}) => {
  const [active, setActive] = useState("");
  const [activePath, setActivePath] = useState("");

  const handleSelect = (item, index) => {
    setActive(item);
    setActivePath(walletPaths[index]);
  };

  const onConfirmation = () => {
    onClose();
    onConfirm(active, activePath);
    setActive("");
    setActivePath("");
  };

  const onCloseHandler = () => {
    onClose();
    setActive("");
    setActivePath("");
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="ledger-modal card  py-4"
    >
      <div className="heading  px-4 mb-1">
        <p>Choose a wallet from your Ledger:</p>
      </div>
      <div className="body py-3 px-4">
        <ul>
          {addressList.length ? (
            addressList.map((item, index) => (
              <li
                className={`mb-2 p-2 d-flex justify-content-between align-items-center  address-container ${
                  active === item ? "active" : ""
                }`}
                key={index}
                tabIndex={0}
                onClick={() => handleSelect(item, index)}
              >
                <p className="col-10  text-truncate mb-0">
                  <span className="address-text">{item}</span>
                </p>
                {active === item ? (
                  <img src={TICK_MARK.SOURCE} alt="tick" className="mb-1" />
                ) : (
                  ""
                )}
              </li>
            ))
          ) : (
            <p className="address-text text-center">
              ledger wallet is loading...
            </p>
          )}
        </ul>
      </div>
      <p className="address-text col-12 text-truncate px-4 pt-2">
        Selected Wallet:{" "}
        {active ? (
          <span className="text-primary">{active}</span>
        ) : (
          <span className="cancel">none</span>
        )}
      </p>
      <div className="mt-3 px-4 d-flex justify-content-between">
        <div className="d-flex button-group">
          <button className=" btn confirm px-3" onClick={onConfirmation}>
            Confirm
          </button>
          <button
            className="btn mx-1 cancel py-0 px-2 mb-2"
            onClick={onCloseHandler}
          >
            Cancel
          </button>
        </div>
        <nav aria-label="Page navigation">
          <ul className="pagination">
            <li className="page-item">
              <button
                className="page-link"
                aria-label="Previous"
                onClick={onPrevious}
                disabled={currentPage == 1}
              >
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>
            <li className="page-item">
              <button className="page-link" onClick={firstPage}>
                {currentPage}
              </button>
            </li>

            <li className="page-item">
              <button className="page-link" aria-label="Next" onClick={onNext}>
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </Modal>
  );
};

export default LedgerWalletAddressModal;
